
import React from "react";
import EventSearchBar from "@/components/events/EventSearchBar";
import EventCategoryFilter from "@/components/events/EventCategoryFilter";

interface EventSearchAndFilterProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  handleSearch: (e: React.FormEvent) => void;
  categoryFilter: string | undefined;
  setCategoryFilter: (category: string | undefined) => void;
}

const EventSearchAndFilter: React.FC<EventSearchAndFilterProps> = ({
  searchTerm,
  setSearchTerm,
  handleSearch,
  categoryFilter,
  setCategoryFilter,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-6">
      <div className="lg:col-span-3">
        <EventSearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          handleSearch={handleSearch}
          className="w-full"
        />
      </div>
      <div className="lg:col-span-1">
        <EventCategoryFilter 
          activeCategory={categoryFilter}
          setActiveCategory={setCategoryFilter}
        />
      </div>
    </div>
  );
};

export default EventSearchAndFilter;
